(function (angular) {
    'use strict';

    angular
     .module('dentist')
     .factory('appointmentService', ['$http','$rootScope', '$interpolate', appointmentServiceFactory]);

    function appointmentServiceFactory($http, $rootScope, $interpolate) {

        var appointmentService = {
            getAllAppointmentsOfPractitioner: getAllAppointmentsOfPractitioner
        };

        return appointmentService;

        function getAllAppointmentsOfPractitioner(practiceParam, practitionerIds, startDate, endDate) {
        	var config = { params: { practitionerIds: practitionerIds, startDate: startDate, endDate: endDate } };
//        	var url = "http://env-5650710.appengine.flow.ch/api/practices/{{practiceId}}/freeTimeSlotsForPractitioners";
        	var url = "/api/practices/{{practiceId}}/freeTimeSlotsForPractitioners";
            return $http.get($interpolate(url)(practiceParam), config)
                .then(getAllComplete)
				    .catch(getAllError);

            function getAllComplete(response) {
                return response;
            }

            function getAllError(error) {
                // any error logging goes here
                console.log(error);

                throw error;
            }
        };

    }
})(window.angular);